import useIsMobile from 'utilities/useIsMobile';
import { IAlignedBox } from '../types';
import DescriptionArea from './components/DescriptionArea';
import ImageArea from './components/ImageArea';
import * as SC from './style';

const AlignedInfoBox = (props: IAlignedBox) => {
  const isMobile = useIsMobile();

  return (
    <SC.AIBInner>
      {props.direction || isMobile ? (
        <>
          <ImageArea {...props} />
          <DescriptionArea {...props} />
        </>
      ) : (
        <>
          <DescriptionArea {...props} />
          <ImageArea {...props} />
        </>
      )}
    </SC.AIBInner>
  );
};

export default AlignedInfoBox;
